<template>
  <div class="extend pricing-modal pricing">
    <div class="container is-narrow is-fluid">
      <p class="title main-title has-text-centered subtitle is-5">You have up to <b>${{ maxCredit }} of credit available</b> if you upgrade today</p>
    </div>

    <div class="pricing-table is-comparative">
      <div v-if="maxCredit < 40" class="pricing-plan is-active is-middle">
        <div class="plan-promo has-text-centered m-t-20">
          <div class="tag is-rounded is-secondary"><b>${{ bestCoupon.value }} Credit Applied</b></div>
        </div>

        <div class="plan-header m-b-10">Starter Yearly</div>

        <div class="plan-description">Host unlimited events for small groups all year</div>

        <div class="plan-price">
          <span class="plan-price-amount">
            <strike><span class="plan-price-currency">$</span>{{ prices['starter'].total }}</strike>
            <span class="plan-price-currency">$</span>{{ prices['starter'].total - bestCoupon.value }}
            <span v-if="isAnnual" class="plan-price-currency">first year</span>
          </span>
        </div>
        <div class="plan-subtitle">about ${{ ((prices['starter'].total - bestCoupon.value) / 12 ).toFixed() }} /mo</div>

        <div class="plan-cta">
          <a @click="startCheckout($event, 'starter', bestCoupon.stripeId)" target="_parent" class="button is-medium is-primary is-fullwidth">Upgrade to Starter Yearly</a>
        </div>

        <div class="plan-items m-b-40">
          <div><span class="emoji">🙋‍♀️</span> <b>Host up to 50 people</b></div>
          <div><span class="emoji">🎬</span>Unlimited interactive events</div>
          <!-- <div><span class="emoji">💬</span> All interaction types</div> -->
          <div><span class="emoji">🎨</span> Custom fonts &amp; design</div>
          <div><span class="emoji">📴</span> Custom event codes</div>
          <!-- <div><span class="emoji">📴</span>Moderator tools (soon)</div> -->
        </div>
      </div>

      <div class="pricing-plan is-active is-last">
        <div class="plan-promo has-text-centered m-t-20">
          <div class="tag is-rounded is-secondary"><b>${{ bestCoupon.value }} Credit Applied</b></div>
          <!-- <div>&nbsp;</div> -->
        </div>
        <div class="plan-header m-b-10">Pro Yearly</div>

        <!-- <b-tooltip label="Click to copy" type="is-dark">
          <div @click="copyText(coupon)" class="coupon-box m-t-40">
            <small>use discount code</small>
            <p>{{ coupon }}</p>
            <div class="copy-button"><i class="far fa-copy" /></div>
          </div>
        </b-tooltip> -->

        <!-- <br> -->
        <div class="plan-description" style="display: inline-block">Host unlimited branded events for large groups for a year.</div>

        <div class="plan-price">
          <span class="plan-price-amount">
            <strike><span class="plan-price-currency">$</span>{{ prices[`pro${proPlayerLimit}`].total }}</strike>
            <span class="plan-price-currency">$</span>{{ prices[`pro${proPlayerLimit}`].total - bestCoupon.value }}
            <span v-if="isAnnual" class="plan-price-currency">first year</span>
          </span>
        </div>
        <div class="plan-subtitle">about ${{ ((prices[`pro${proPlayerLimit}`].total - bestCoupon.value) / 12 ).toFixed() }} /mo</div>

        <div class="limit-toggle">
          <div class="b-numberinput field is-grouped">
            <p class="control minus">
              <button @click="decreasePlayerLimit()" :disabled="decreaseLimitDisabled" type="button" class="button is-primary">
                <span class="icon"><i class="fas fa-minus" /></span>
              </button>
            </p>
            <div class="control is-clearfix" style="user-select: none">
              <button class="input">{{ proPlayerLimit }} people</button>
            </div>
            <p class="control plus">
              <button @click="increasePlayerLimit()" :disabled="increaseLimitDisabled" type="button" class="button is-primary">
                <span class="icon"><i class="fas fa-plus" /></span>
              </button>
            </p>
          </div>
        </div>

        <div class="plan-cta">
          <a @click.prevent="startCheckout($event, `pro${proPlayerLimit}`, bestCoupon.stripeId)" target="_parent" class="button is-medium is-fullwidth is-primary">Upgrade to Pro Yearly</a>
        </div>

        <div class="plan-items m-b-40">
          <div><span class="emoji">🙋‍♀️</span> <b>Host up to {{ proPlayerLimit }} people</b></div>
          <div><span class="emoji">🎬</span>Unlimited interactive events</div>
          <!-- <div><span class="emoji">💬</span> All interaction types</div> -->
          <div><span class="emoji">🎨</span> Custom fonts &amp; design</div>
          <div><span class="emoji">📦</span>Remove SlidesWith logo</div>
          <div><span class="emoji">💾</span> Save &amp; export event data</div>
          <div><span class="emoji">📴</span> Custom event codes</div>
          <!-- <div><span class="emoji">📴</span>Moderator tools (soon)</div> -->
        </div>
      </div>
    </div>

    <div class="level has-text-centered m-t-50">
      <div class="level-item">
        <div @click="$emit('close')" class="button is-darkened is-dark is-medium">Not right now</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import PricingControls from '~/components/mixins/PricingControls.vue'

export default {
  name: 'ExtendPass',
  mixins: [PricingControls],
  data () {
    return {
      isAnnual: true,
      successUrl: process.env.SITE_URL + '/decks?success',
      cancelUrl: process.env.SITE_URL + '/decks?cancel',
      couponIds: {
        test: {
          starter: 'cfpvWDVd',
          pro100: 'vVu02LBD',
          pro250: 'uFC9CenH',
          pro500: 'ehnnkxFa',
          pro1000: '4r5vpGhA'
        },
        live: {
          starter: 'eTMqRIsq', // old coupon: 'd4rc0Z7s',
          pro100: 'uz2PX1rJ',
          pro250: 'b5fkPjTq', // old coupon: 'fxPYVb5s',
          pro500: 'ljKjfHFo',
          pro1000: 'yYw7P1Wt'
        }
      },
      passValues: {
        starter: 35,
        pro100: 69,
        pro250: 99,
        pro500: 199,
        pro1000: 299
      }
    }
  },
  computed: {
    ...mapState([
      'user'
    ]),
    ...mapGetters([
      'eventPasses',
      'isPassActive'
    ]),
    pass () {
      return this.eventPasses
    },
    bestCoupon () {
      const couponIds = this.isDev ? this.couponIds.test : this.couponIds.live
      const coupon = {}

      const maxSelectionValue = this.passValues[`pro${this.proPlayerLimit}`]

      if (maxSelectionValue < this.maxCredit) {
        coupon.value = maxSelectionValue
        coupon.stripeId = couponIds[`pro${this.proPlayerLimit}`]
      } else {
        coupon.value = this.maxCredit
        coupon.stripeId = couponIds[this.pass.bestPass]
      }

      return coupon
    },
    maxCredit () {
      const bestPass = this.pass.bestPass
      if (bestPass === 'starter') { return 35 }
      if (bestPass === 'pro100') { return 69 }
      if (bestPass === 'pro250' || bestPass === 'pro') { return 99 }
      if (bestPass === 'pro500') { return 199 }
      if (bestPass === 'pro1000') { return 299 }
      return 0
    },
    loggedIn () {
      return this.$auth.loggedIn
    },
    lineItems () {
      return this.priceIds.yearly
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>

<style lang="scss">
.modal.upgrade-modal.is-full-screen .modal-content {
  background-color: #8268a1;

  .main-title.title {
    color: white;
  }
}
</style>

<style lang="scss" scoped>
.pricing {
  .limit-toggle {
    max-width: 300px;
    margin: 0em auto 1em;
    text-align: center;

    .button {
      justify-content: center;
    }
  }

  mark {
    background-color: rgb(255, 223, 229);
  }
  .pricing-table {
    justify-content: center;

    .pricing-plan, .pricing-plan.is-active {
      width: 34%;
      border: 1px solid #eee;
      box-shadow: 1px 10px 34px -14px rgba(31, 51, 73, .15);
      margin-right: 2.5%;
      border-radius: 14px;
      max-width: 450px;

      &:hover {
        transform: none;
      }

      &.is-last {
        // border-top-left-radius: 0px;
        // border-bottom-left-radius: 0px;
        margin-left: -1px;
        margin-right: 0;
      }

      &.is-active:hover {
        z-index: 1;
      }

      &.is-free {
        width: 25%;
      }
    }

    .plan-cta {
      margin: .85em 3em 2em;
    }

    .plan-description {
      font-size: 1em !important;
    }

    .plan-price {
      // background-color: #e207621f;
      // background-color: #8268a12b;
      color: #222;
      margin: 1em 2.25em 0;
      border-radius: 6px;
      padding-bottom: 1.25em;

      .plan-price-amount {
        color: black !important;
      }
    }

      .plan-header {
        color: var(--primary);
        // text-transform: uppercase;
        font-weight: bold;
        font-size: 2.25em;
        padding-top: .25em !important;
        margin-bottom: 5px;
      }

    .plan-items {
      color: #666;
      text-align: center;
      font-size: 1.15em;

      div {
        margin-bottom: .15em;
      }

      .emoji {
        font-size: .85em;
        margin-right: 2px;
        opacity: .8;
      }
    }

    .plan-price-amount {
      strike {
        color: #aaa;
        font-size: .75em;
        margin-left: -1.5em;
        display: inline-block;
        transform: rotate(-6deg);

        .plan-price-currency {
          color: #aaa;
        }
      }
    }
  }

  .annual-switch {
    min-width: 266px;

    .is-content {
      width: 50%;
    }
  }

  .coupon-box {
    background-color: rgb(226, 236, 248);
    // border: 2px solid #00adff;
    border-radius: 6px;
    // margin: 20px auto 10px;
    margin: 0 auto;
    padding: 10px;
    width: 90%;
    color: #00adff;
    font-weight: bold;
    font-size: .9em;
    position: relative;
    text-align: center;
    cursor: pointer;

    p {
      margin-top: -10px;
      font-size: 2.2em;
      color: #00adff;
      font-weight: bold;
      letter-spacing: -1px;
      pointer-events:none;

    }

    .copy-button {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 8%;
      font-size: 1.5em;
    }
  }

  @media screen and (max-width: 768px) {
    .container.is-fluid {
      padding: 0px;
    }

    .pricing-table {
      flex-direction: column;

      .pricing-plan {
        width: 100% !important;

        .plan-header {
          padding-top: 0;
        }
      }
    }
  }
}
</style>
